import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { IonInput, IonItem } from '@ionic/vue';

//Emits

export default /*#__PURE__*/_defineComponent({
  __name: 'AppInput',
  props: {
  placeholder: { type: String, required: false },
  modelValue: { type: String, required: false },
  readonly: { type: Boolean, required: false }
},
  emits: ['valueChanged', 'update:modelValue'],
  setup(__props, { emit }) {

const props = __props;



//Props


//Functions
function handleChange(event: any) {
  emit('valueChanged', event)
  emit('update:modelValue', event.detail.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonItem), {
    class: "appInput",
    lines: __props.readonly ? 'none' : 'full'
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonInput), {
        placeholder: props.placeholder,
        value: props.modelValue,
        readonly: __props.readonly,
        onIonChange: _cache[0] || (_cache[0] = ($event: any) => (handleChange($event)))
      }, null, 8, ["placeholder", "value", "readonly"])
    ]),
    _: 1
  }, 8, ["lines"]))
}
}

})